var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VFormBuilder',{ref:"form",attrs:{"items":_vm.items,"initial-values":_vm.initialValues},scopedSlots:_vm._u([{key:"item.url.after",fn:function(ref){
var form = ref.form;
return [_c('ActionForm',{ref:"action",attrs:{"items":_vm.initialValues && _vm.initialValues.actions ? _vm.initialValues.actions : []}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }